import { useSelector } from 'react-redux'

import { ApplicationState } from 'redux/Stores/types'
import { selectObjectSizeMappings } from 'redux/selectors/internal/ObjectSizeMapper'

export const useObjectSizeMappings = (customerId: string) => {
  return useSelector((state: ApplicationState) =>
    selectObjectSizeMappings(state, customerId)
  )
}
